<div *ngIf="processStatus" class="job-row"
     [pTooltip]="rowTooltip"
     tooltipPosition="left"
     tooltipStyleClass="text-sm results-tooltip"
     [showDelay]="400">

  <!-- Main row: icon · tool name · progress · actions -->
  <div class="job-row-main">
    <i [ngClass]="determineIconFromState() + ' job-state-icon'"
       [pTooltip]="tooltipContent()" tooltipPosition="left"
       tooltipStyleClass="text-sm" [autoHide]="state !== State.ERROR"></i>

    <span class="job-tool-name" [title]="processStatus.info">{{ toolDisplayName }}</span>

    <span *ngIf="isActive" class="job-progress">
      <p-progressBar [value]="percentComplete" [showValue]="false"
                     styleClass="job-progress-bar"></p-progressBar>
      <span class="job-percent text-xs">{{ percentComplete }}%</span>
    </span>

    <span class="job-actions">
      <button *ngIf="hasResults" pButton type="button" icon="pi pi-folder-open"
              class="p-button-text p-button-sm p-button-rounded job-action-btn"
              pTooltip="View results" tooltipPosition="left"
              (click)="onViewResults()"></button>
      <button *ngIf="showTerminate()" pButton type="button" icon="pi pi-times"
              class="p-button-text p-button-danger p-button-sm p-button-rounded job-action-btn"
              pTooltip="Cancel job" tooltipPosition="left"
              (click)="onClickTerminate()"></button>
    </span>
  </div>

  <!-- Sub row: input path -->
  <div class="job-row-sub">
    <span class="job-input-path text-xs" [title]="processStatus.submissionInput || ''">
      {{ shortInputPath }}
    </span>
  </div>

  <!-- Message row -->
  <div *ngIf="message" class="job-row-sub">
    <span class="job-message text-xs"
          [ngClass]="{'job-error-text': state === State.ERROR}">
      {{ shortMessage }}
    </span>
  </div>

</div>
